export const artists = [
    {
        "name": "BOSS DOMS",
        "date": "July 9",
        "description": "",
        "image": "boss-doms",
        //"service":"spotify",
        //"playlist": "https://open.spotify.com/artist/18YBSDKYgR6so2I94gqUQ9?si=uRhIfv3LSreP8ahC6g7o6g"
    },
    {
        "name": "JIMMY SAX",
        "date": "July 10 - Porto di Scauri",
        "description": "Special Guest",
        "image": "jimmy-sax"
    },
    {
        "name": "SVEN VÄTH",
        "date": "July 10",
        "description": "",
        "image": "sven-vath",
        //"service":"spotify",
        //"playlist": "https://open.spotify.com/artist/18YBSDKYgR6so2I94gqUQ9?si=uRhIfv3LSreP8ahC6g7o6g"
    },
    {
        "name": "MACE",
        "date": "July 11",
        "description": "",
        "image": "mace",
        //"service":"spotify",
        //"playlist": "https://open.spotify.com/artist/18YBSDKYgR6so2I94gqUQ9?si=uRhIfv3LSreP8ahC6g7o6g"
    }
]
